import styled from 'styled-components';

export const EllipsisWrapper = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
